import fetchRefreshToken from './fetchRefreshToken'

const fetchGetAppLogsParams = async (payload) => {
  console.log({payload})
    const response = await fetchRefreshToken().then(async newToken => {
      
      const res = await fetch(`${process.env.REACT_APP_FETCH_DEV}rest/params/selected`, {
        method: "POST",
        headers:{
          'Authorization': `Bearer ${newToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }).then(response => response.json())
      
      return res
    })

    return response
}

  export default fetchGetAppLogsParams